import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAdminLogout = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 28 28",
	fill: "none",
	stroke: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		transform: "scale(1.9) translate(-6.5,-6.5)",
		d: "M17.87 12.87V12c0-2.15-1.71-3.94-3.81-4h-.09c-1.03 0-2.01.4-2.75 1.11-.76.73-1.19 1.75-1.19 2.81v.97c-.57.14-1.17.65-1.17 1.24v4.61c0 .7.56 1.27 1.26 1.27h7.77c.7 0 1.271-.569 1.271-1.27v-4.61c-.001-.62-.69-1.14-1.291-1.26zm-5.63-.95c0-.49.209-.95.57-1.27a1.686 1.686 0 0 1 1.33-.43c.879.12 1.53.87 1.52 1.75v.88h-3.42v-.93zm2.1 6.88l-.791-.59.92-1.229h-2.43V15.97h2.43l-.869-1.15.79-.59 1.69 2.241-1.74 2.329z"
	})
});
export default SvgAdminLogout;
